// export const BACKEND_URL = "http://localhost:5000";
export const BACKEND_URL = "https://youit-social-network.herokuapp.com";
// export const FRONTEND_URL = "http://localhost:3000";
export const FRONTEND_URL = "https://youit-social-network.netlify.app";

export const GITHUB_CLIENT_ID = "27be412895ac6f012f8a";
export const GITHUB_CLIENT_SECRET = "deb7458ae5babcb388b53a97179f2be71689e36a";
